import React  from 'react';

const Languages = props => {

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'row',
      }}>
      <img
        onClick={() => props.changeLanguage('fr')}
        src={require('../../assets/flag/ico-fr.png')}
        style={{
          marginRight: 9,
          marginLeft: 5,
          width: 50,
          opacity: props.language === 'fr' ? '1' : '0.3',
        }}
        alt="fr"
      />
      <img
        onClick={() => props.changeLanguage('en')}
        src={require('../../assets/flag/ico-uk.png')}
        style={{
          marginRight: 9,
          marginLeft: 5,
          width: 50,
          opacity: props.language === 'en' ? '1' : '0.3',
        }}
        alt="en"
      />
      <img
        onClick={() => props.changeLanguage('es')}
        src={require('../../assets/flag/ico-es.png')}
        style={{
          marginRight: 9,
          marginLeft: 5,
          width: 50,
          opacity: props.language === 'es' ? '1' : '0.3',
        }}
        alt="es"
      />
      <img
        onClick={() => props.changeLanguage('eu')}
        src={require('../../assets/flag/ico-bask.png')}
        style={{
          marginRight: 9,
          marginLeft: 5,
          width: 50,
          opacity: props.language === 'eu' ? '1' : '0.3',
        }}
        alt="eu"
      />
    </div>
  );
};

export default Languages;
